import React, { useState, useEffect } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import Card from "../../../components/Card";
import { postApiCall } from "../../../service/httpCall";
import { API_AGENT_ANNOUNCEMENT_CREATE } from "../../../../src/service/url";
import { ROUTES, STATUS } from "../../../utilities/constant";
import { useAuth } from '../auth/auth-utils';

const AgentAnnouncementCreate = () => {
    const navigate = useNavigate();
    const { checkAuth } = useAuth();
    const [heading, setHeading] = useState("");
    const [content, setContent] = useState("");
    const [status, setStatus] = useState("");
    const [buttonDisable, setButtonDisable] = useState(false);

    useEffect(() => { checkAuth(() => { }, () => { }) }, []);

    const submitForm = async () => {
        if (!heading.trim() || !content.trim()) {
            return toast.warning("All fields are required");
        }
        setButtonDisable(true);
        const params = { heading, content};

        console.log("FULL URL:", API_AGENT_ANNOUNCEMENT_CREATE);

        postApiCall(API_AGENT_ANNOUNCEMENT_CREATE, params)
            .then(() => {
                toast.success("Announcement created successfully");
                setTimeout(() => navigate(`/${ROUTES.AGENT_ANNOUNCEMENT.LIST}`), 1500);
            })
            .catch((err) => {
            const errorMsg = err|| "Something went wrong";
            toast.error(errorMsg); 
            setButtonDisable(false);
        });
    };

    return (
        <Row>
            <Col xl="12">
                <Card>
                    <Card.Header><h4>New Agent Announcement</h4></Card.Header>
                    <Card.Body>
                        <Form>
                            <Row>
                                <Form.Group className="col-md-6 mb-3">
                                    <Form.Label>Heading <span className="text-danger">*</span></Form.Label>
                                    <Form.Control type="text" value={heading} onChange={(e) => setHeading(e.target.value)} placeholder="Enter Heading" />
                                </Form.Group>
                                {/* <Form.Group className="col-md-6 mb-3">
                                    <Form.Label>Status <span className="text-danger">*</span></Form.Label>
                                    <Form.Select value={status} onChange={(e) => setStatus(e.target.value)}>
                                        <option value="">Select Status</option>
                                        {STATUS.map((val, idx) => <option key={idx} value={val.value}>{val.label}</option>)}
                                    </Form.Select>
                                </Form.Group> */}
                                <Form.Group className="col-md-12 mb-3">
                                    <Form.Label>Content <span className="text-danger">*</span></Form.Label>
                                    <Form.Control as="textarea" rows={3} value={content} onChange={(e) => setContent(e.target.value)} placeholder="Enter Content" />
                                </Form.Group>
                            </Row>
                            <Button onClick={submitForm} disabled={buttonDisable}>
                                {buttonDisable ? "Processing..." : "Add Announcement"}
                            </Button>
                        </Form>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};

export default AgentAnnouncementCreate;